import { RobotDeadOutlineIcon } from './RobotDeadOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 15D146E0-3683-43D8-8500-905EEAC98010
 * name robot-dead-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-dead-outline.svg
 * tags
 */
export const EmoticonRobotDeadOutlineIcon = RobotDeadOutlineIcon;
export default EmoticonRobotDeadOutlineIcon